import React from 'react';
import { useMount } from '@shared/utils/hooks/useMount';
import { useHotelBookingGuestSiteTelemetry } from '../../HotelBooking.telemetry';
import { useHotelBookingRedirectHealth, wrapWithHotelBookingRedirectProvider } from '../../HotelBooking.health';
import { useEventDisplayName } from '@shared/utils/eventInfo/useEventDisplayName';
import { useHotelSearchConfig } from './useHotelSearchConfig';
import { useQueryParamHelper } from '@shared/core/queryString';
import { HotelSearchContextParams } from '@shared/constants/accommodations';

// Sync import: bundled into this chunk to avoid a double lazy-load waterfall.
// See TRAV-2638 for performance analysis.
import { OtaAccommodationsConsole } from '@apps/stays/AccommodationsConsole/scenarios/ota/OtaAccommodationsConsole';

export const OtaHotelSearch = wrapWithHotelBookingRedirectProvider(({ eventHandle }: { eventHandle: string }) => {
  const { onLoadComplete } = useHotelBookingRedirectHealth();
  const telemetry = useHotelBookingGuestSiteTelemetry();
  const eventDisplayName = useEventDisplayName();
  const queryParamHelper = useQueryParamHelper();

  const { layout } = useHotelSearchConfig();

  const selectedHotelId = queryParamHelper.getValueString(HotelSearchContextParams.selectedHotel) || undefined;

  useMount(() => {
    onLoadComplete();
    telemetry.hotelSearch.enter();
  });

  return (
    <OtaAccommodationsConsole
      eventHandle={eventHandle}
      eventName={eventDisplayName}
      selectedHotelId={selectedHotelId}
      layout={layout}
    />
  );
});
